import {MenuStateType} from 'appmodule/home/reducer/MenuReducer';
import {ModuleType} from 'generated/JavaTO'
import _ from 'lodash';

export const selMenuItems = (state: MenuStateType) => {
	return _.filter(state.Menu.Items, item => item.modulTyp !== ModuleType.EVOAPPS_HIDDEN);
}
export const selMenuStyle = (state: MenuStateType) => state.Menu.menuStyle
export const selMenuRefreshTS = (state: MenuStateType) => state.Menu.refreshTS